import {
    FaShoppingCart,
    FaWallet,
    FaShieldAlt,
    FaMobileAlt,
    FaCalendarAlt,
    FaBell, 
    FaChartLine,
    FaTasks,
    FaUsers
  } from "react-icons/fa";
  
  import { MdInventory, MdDashboard } from "react-icons/md";
  import { SiBlockchaindotcom } from "react-icons/si";
  
  function Projects() {
  
    const mobileProjects = [
      {
        icon: <FaShoppingCart />,
        title: "Ecommerce Mobile App",
        desc: "React Native mobile application with product search, secure payments and push notifications.",
        tech: ["React Native", "Redux", "Firebase"],
      },
      {
        icon: <FaWallet />,
        title: "Blockchain Wallet",
        desc: "Multi-network crypto wallet built with React Native enabling secure blockchain transactions.",
        tech: ["React Native", "Web3"],
      },
      {
        icon: <FaShieldAlt />,
        title: "Insurance Mobile App",
        desc: "Mobile insurance platform for policy management and claims tracking.",
        tech: ["React Native", "REST API"],
      },
      {
        icon: <MdInventory />,
        title: "Inventory Management System",
        desc: "Retail inventory management system with product tracking and order management.",
        tech: ["React Native", "Redux"],
      },
      {
        icon: <FaMobileAlt />,
        title: "Customer Loyalty App",
        desc: "Mobile loyalty platform with rewards, offers and customer engagement features.",
        tech: ["React Native", "Firebase"],
      },
      {
        icon: <SiBlockchaindotcom />,
        title: "Paycircle Fintech App",
        desc: "Secure fintech payment application supporting onboarding with KYC/KYB, OTP verification and MPIN authentication.",
        tech: ["React Native", "Redux", "WebSocket", "Firebase"],
      },
    ];
  
    const webProjects = [
      {
        icon: <FaCalendarAlt />,
        title: "Nissan Schedule Management",
        desc: "Enterprise React.js platform enabling technicians to manage service schedules and workflow tasks.",
        tech: ["React.js", "Redux", "REST API"],
      },
      {
        icon: <MdDashboard />,
        title: "Retail Order Management Dashboard",
        desc: "React.js dashboard for monitoring orders, inventory and analytics in real time.",
        tech: ["React.js", "Redux", "REST API"],
      },
      {
        icon: <FaBell />,
        title: "Notification Management Portal",
        desc: "Web platform for scheduling and managing push notifications across applications.",
        tech: ["React.js", "Firebase"],
      },
      
      {
        icon: <FaTasks />,
        title: "Task Management System",
        desc: "Web application for creating, assigning and tracking tasks across teams with real-time updates.",
        tech: ["React.js", "Redux", "REST API"]
      },
      
      {
        icon: <FaUsers />,
        title: "User Management Portal",
        desc: "Enterprise portal for managing users, roles and permissions with secure authentication and role-based access control.",
        tech: ["React.js", "Redux", "REST API"]
      },
      
      {
        icon: <FaShoppingCart />,
        title: "Retail Product Management",
        desc: "Product management platform allowing administrators to manage inventory, pricing and catalog updates.",
        tech: ["React.js", "Redux", "REST API"]
      },
      
      {
        icon: <FaChartLine />,
        title: "Business Reporting Dashboard",
        desc: "Interactive reporting dashboard displaying sales insights, performance metrics and operational data.",
        tech: ["React.js", "REST API", "Chart.js"]
      }
    ];
  
    const renderProjects = (projects) =>
      projects.map((project, index) => (
        <div
          key={index}
          className="bg-[#1b2433]/90 backdrop-blur-md rounded-xl overflow-hidden shadow-[0_0_30px_rgba(59,130,246,0.15)] hover:shadow-[0_0_50px_rgba(59,130,246,0.35)] transition"
        >
          <div className="h-28 bg-gradient-to-r from-blue-500/30 to-indigo-500/30 flex items-center justify-center text-4xl text-blue-300">
            {project.icon}
          </div>
  
          <div className="p-6">
            <h2 className="text-xl font-semibold">{project.title}</h2>
  
            <p className="text-gray-400 mt-2 text-sm">{project.desc}</p>
  
            <div className="flex flex-wrap gap-2 mt-4">
              {project.tech.map((tech, i) => (
                <span
                  key={i}
                  className="text-xs bg-blue-500/20 text-blue-300 px-3 py-1 rounded-full"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      ));
  
    return (
      <section className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#0f1d3a] to-[#0a1f44] text-white pt-40 pb-20">
  
        <div className="max-w-7xl mx-auto px-6">
  
          <h1 className="text-4xl font-bold text-center mb-20">
            Projects
          </h1>
  
          {/* Mobile Apps */}
  
          <h2 className="text-2xl font-semibold mb-8 text-blue-300">
            Mobile Applications
          </h2>
  
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 mb-20">
            {renderProjects(mobileProjects)}
          </div>
  
          {/* Web Apps */}
  
          <h2 className="text-2xl font-semibold mb-8 text-blue-300">
            Web Applications
          </h2>
  
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
            {renderProjects(webProjects)}
          </div>
  
        </div>
  
      </section>
    );
  }
  
  export default Projects;